import { __assign } from 'tslib';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { KMosaicAnimationType } from './KMosaicElement/index.props.js';

var StyledKMosaic = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "animationType"; }
})(function (_a) {
    var animationType = _a.animationType;
    return (__assign({}, (animationType &&
        animationType === KMosaicAnimationType.ZoomOnHover && {
        "&  .KMosaicElement-media": {
            transition: "all 250ms ease-out"
        },
        "& .KMosaicElement-action": {
            overflow: "hidden"
        },
        "& .KMosaicElement-media img": {
            transition: "all 250ms ease-out",
            scale: "1",
            "&:hover": {
                scale: "1.1"
            }
        }
    })));
});

export { StyledKMosaic as default };
//# sourceMappingURL=index.styled.js.map
